import { render, staticRenderFns } from "./FileInputWithPreview.vue?vue&type=template&id=04bd067e"
import script from "./FileInputWithPreview.vue?vue&type=script&lang=js"
export * from "./FileInputWithPreview.vue?vue&type=script&lang=js"
import style0 from "./FileInputWithPreview.vue?vue&type=style&index=0&id=04bd067e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports